import { c as _c } from "react/compiler-runtime";
import loveEyesEmoji from "@website/widget/reserve-comment/reserve-comment-avavtar/assets/love-eyes-emoji.svg";
import pokerFaceEmoji from "@website/widget/reserve-comment/reserve-comment-avavtar/assets/poker-face-emoji.svg";
import sadEmoji from "@website/widget/reserve-comment/reserve-comment-avavtar/assets/sad-emoji.svg";
import { ReserveCommentAvatarPropertiesType } from "@website/widget/reserve-comment/reserve-comment-avavtar/reserve-comment-avatar.types";
export const ReserveCommentAvatar = t0 => {
  const $ = _c(4);
  const {
    rate,
    className
  } = t0;
  const t1 = rate < 2 ? "sad-emoji" : rate >= 2 && rate < 4 ? "poker-emoji" : "love-eyes-emoji";
  const t2 = rate < 2 ? sadEmoji?.src : rate >= 2 && rate < 4 ? pokerFaceEmoji?.src : loveEyesEmoji?.src;
  let t3;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2) {
    t3 = <img alt={t1} className={className} height={32} loading="lazy" src={t2} width={32} />;
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};